import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.D1CTlYx0.js","_app/immutable/chunks/disclose-version.DQqMciGL.js","_app/immutable/chunks/runtime.4tlg2WhF.js","_app/immutable/chunks/legacy.BTby3Cl7.js","_app/immutable/chunks/lifecycle.CjAMxTXn.js","_app/immutable/chunks/props.X-9wbahI.js","_app/immutable/chunks/Loading.TJpIxKCR.js","_app/immutable/chunks/render.C03RQbLD.js","_app/immutable/chunks/slot.BVlYFKWW.js","_app/immutable/chunks/index-client.DZ3evCgP.js","_app/immutable/chunks/entry.B_unJ21J.js"];
export const stylesheets = ["_app/immutable/assets/2.I-YOC0Je.css","_app/immutable/assets/Loading.2QRZDmh7.css"];
export const fonts = [];
